<template>
<span>
    <div class="animate__animated animate__fadeInLeft animate__faster">
    <div class="app__title bg-dark--custom pt-4">
      <h2 class="m-0 text-center" style="color: white">Mi historial</h2>
    </div>

    <main class="app__main mt-0">
      <div class="table-responsive card-body--custom p-0">
        <div class="alert alert-danger text-center m-0 col-12" v-if="historial.length === 0">Aún no tienes un historial que mostrar</div>
        <table class="table table-striped table--custom" v-else>
          <thead class="thead-dark">
            <th>Auto</th>
            <th>Inicio</th>
            <th>Fin</th>
            <th>Total</th>
          </thead>
          <tbody>
            <tr v-for="(historia, h) in historial" :key="h">
              <td>{{ historia.DescripcionVehiculo }}</td>
              <td>{{ historia.VigenciaInicialActivacion }}</td>
              <td>{{ historia.VigenciaFinalActivacion }}</td>
              <td>${{ historia.PrimaTotal }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
  <Navigation />
</span>
</template>

<script>
import Navigation from '../../componentes/Navbar.vue'
export default {
  components: {
    Navigation
  },
  methods: {
    handleDate(dateStart, dateEnd) {
      const fecha1 = new Date(dateStart);
      const fecha2 = new Date(dateEnd);

      const resta = fecha2.getTime() - fecha1.getTime();
      return new Date(resta).getDate();
    }
  },
  computed: {
    historial() {
      return this.$store.state.historial;
    }
  }
}
</script>